import React from 'react'
import './Footer.css'

const Footer = ({ colourScheme }) => {
    return (
        <div className={`footer-container ${colourScheme}-footer`}>
            <div className="footer-content">
                <p className="footer-text">Powered by</p>
                <img src={require(`../../Assets/custom-site/${colourScheme}/footer-logo.png`)} alt="First Dance" className="footer-logo" />
            </div>
        </div>
    )
}

export default Footer